__turbopack_context__.v({
  "dropdown": "mgxINW_dropdown",
  "option": "mgxINW_option",
  "selected-option": "mgxINW_selected-option",
});
